import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-connection-lost-modal',
    templateUrl: './connection-lost-modal.component.html',
    styleUrls: ['./connection-lost-modal.component.scss'],
    standalone: false
})
export class ConnectionLostModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
